import React from 'react';
import { Switch, Box, useTheme as useMuiTheme } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';

const ThemeToggle = () => {
  const { t } = useTranslation();
  const muiTheme = useMuiTheme();
  const { mode, toggleTheme } = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {mode === 'light' ? (
          <LightModeIcon
              fontSize="small"
              sx={{
                  color: 'text.secondary'
              }}
          />
        ) : (
          <DarkModeIcon
              fontSize="small"
              sx={{
                  color: 'text.secondary'
              }}
          />
        )}
        <Switch
          checked={mode === 'dark'}
          onChange={toggleTheme}
          aria-label={t('themeToggleAriaLabel')}
          size="small"
        />
    </Box>
  );
};

export default ThemeToggle; 